// extracted by mini-css-extract-plugin
export var article = "article-module--article--syldC";
export var articleContent = "article-module--article-content--cJFSQ";
export var articleImage = "article-module--article-image--leK5r";
export var meta = "article-module--meta--wxL6R";
export var tagSeparator = "article-module--tagSeparator--SF1ke";